export const CheckIcon = ({ color }) => (
  <svg width="12" height="9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.2491 6.4325L1.8166 4l-.8283.8225L4.249 8.0834l7-7-.8225-.8225-6.1775 6.1716z" fill={color ? color : "#343332"} />
  </svg>
);